// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentCont[data-v-2bfc2409] {\n  padding: 24px;\n  padding-top: 0px;\n  height: calc(100% - 33px);\n  overflow: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
